<p-toast></p-toast>
<p-card>
  <div class="flex flex-col items-center gap-4 justify-between h-[60vh] w-[80vw]
           sm:h-[70vh] sm:w-auto sm:min-w-[25vw] p-1 lg:p-4">
    <img alt="Sisdemanda" height="98" ngSrc="logo.png" width="300"/>
    <p class="text-sm text-center break-words leading-relaxed font-[Rawline]">
      Token enviado para:<br/>
      <span class="font-semibold">{{ email }}</span>
    </p>
    <div class="w-full space-y-2">
      <label class="block text-sm text-gray-700" for="tokenInput">Digite o token</label>
      <input
        (keydown.enter)="verifyToken()"
        [formControl]="tokenCtrl"
        class="w-full p-2 border rounded"
        id="tokenInput" name="token"
        type="text"
      />
    </div>
    <div class="w-full flex flex-col gap-2">
      <p-button (click)="verifyToken()"
          (keydown.enter)="$event.preventDefault(); verifyToken()"
          (keydown.space)="$event.preventDefault(); verifyToken()" class="w-full" styleClass="btn-gray">
        <app-icon-entrar-login></app-icon-entrar-login>
        Entrar
      </p-button>
      <a (click)="onRequestNewToken()"
         class="cursor-pointer text-sm block text-center text-[#0076d6] hover:text-[#0b4778]">
        Enviar token novamente
      </a>
    </div>
  </div>
</p-card>
